import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=3aed80a4&scoped=true&"
import script from "./Popup.vue?vue&type=script&lang=ts&"
export * from "./Popup.vue?vue&type=script&lang=ts&"
import style0 from "./Popup.vue?vue&type=style&index=0&id=3aed80a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aed80a4",
  null
  
)

export default component.exports